function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import CropperElement from '@cropper/element';
import { CROPPER_GIRD } from '@cropper/utils';
var style = ":host{display:flex;flex-direction:column;position:relative;touch-action:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}:host([bordered]){border:1px dashed var(--theme-color)}:host([covered]){bottom:0;left:0;position:absolute;right:0;top:0}:host>span{display:flex;flex:1}:host>span+span{border-top:1px dashed var(--theme-color)}:host>span>span{flex:1}:host>span>span+span{border-left:1px dashed var(--theme-color)}";

var CropperGrid = /*#__PURE__*/function (_CropperElement) {
  _inherits(CropperGrid, _CropperElement);

  var _super = _createSuper(CropperGrid);

  function CropperGrid() {
    var _this;

    _classCallCheck(this, CropperGrid);

    _this = _super.apply(this, arguments);
    _this.$style = style;
    _this.bordered = false;
    _this.columns = 3;
    _this.covered = false;
    _this.rows = 3;
    _this.slottable = false;
    _this.themeColor = 'rgba(238, 238, 238, 0.5)';
    return _this;
  }

  _createClass(CropperGrid, [{
    key: "$propertyChangedCallback",
    value: function $propertyChangedCallback(name, oldValue, newValue) {
      var _this2 = this;

      if (Object.is(newValue, oldValue)) {
        return;
      }

      _get(_getPrototypeOf(CropperGrid.prototype), "$propertyChangedCallback", this).call(this, name, oldValue, newValue);

      if (name === 'rows' || name === 'columns') {
        this.$nextTick(function () {
          _this2.$render();
        });
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(CropperGrid.prototype), "connectedCallback", this).call(this);

      this.$render();
    }
  }, {
    key: "$render",
    value: function $render() {
      var shadow = this.$getShadowRoot();
      var fragment = document.createDocumentFragment();

      for (var i = 0; i < this.rows; i += 1) {
        var row = document.createElement('span');
        row.setAttribute('role', 'row');

        for (var j = 0; j < this.columns; j += 1) {
          var column = document.createElement('span');
          column.setAttribute('role', 'gridcell');
          row.appendChild(column);
        }

        fragment.appendChild(row);
      }

      if (shadow) {
        shadow.innerHTML = '';
        shadow.appendChild(fragment);
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return _get(_getPrototypeOf(CropperGrid), "observedAttributes", this).concat(['bordered', 'columns', 'covered', 'rows']);
    }
  }]);

  return CropperGrid;
}(CropperElement);

CropperGrid.$name = CROPPER_GIRD;
CropperGrid.$version = '2.1.0';
export { CropperGrid as default };